export { AccountOpeningV2BeneficiaryDetailStep } from './AccountOpeningV2BeneficiaryDetailStep';
